import { math } from "polished";
export default function makePadding(paddings, { spacing }) {
    return function padding(size, borderWidth) {
        const paddingSize = paddings[size];
        if (typeof paddingSize === "number")
            return `${math(`${spacing(paddingSize)} - ${borderWidth}`)}`;
        return spacing(paddingSize.y, paddingSize.x)
            .split(" ")
            .map(paddingSize => `${math(`${paddingSize} - ${borderWidth}`)}`)
            .join(" ");
    };
}
//# sourceMappingURL=make-padding.js.map